import { render, staticRenderFns } from "./uploading.vue?vue&type=template&id=b2557c34&scoped=true&"
import script from "./uploading.vue?vue&type=script&lang=js&"
export * from "./uploading.vue?vue&type=script&lang=js&"
import style0 from "./uploading.vue?vue&type=style&index=0&id=b2557c34&lang=scss&scoped=true&"
import style1 from "./uploading.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2557c34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/private_library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2557c34')) {
      api.createRecord('b2557c34', component.options)
    } else {
      api.reload('b2557c34', component.options)
    }
    module.hot.accept("./uploading.vue?vue&type=template&id=b2557c34&scoped=true&", function () {
      api.rerender('b2557c34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/uploading.vue"
export default component.exports